import script from "./PageSubmenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSubmenu.vue?vue&type=script&setup=true&lang=js"

import "./PageSubmenu.vue?vue&type=style&index=0&id=550672c7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-550672c7"]])

export default __exports__